import {WORDPRESS_URL} from '../config';

const DOUBLE_QUOTES = /[“”„″]/g;  // “ ” „ ″
const SINGLE_QUOTES = /[‘’‚]/g;        // ‘ ’ ‚
const NO_BREAK_SPACE = / /g;
const OWN_HTTP_URL = /http:\/\/((?:www\.|wordpress\.)?vch-online\.at)/g;

/** Strips the tags of an HTML fragment and decodes its entities. */
export function htmlToText(html: string): string {
    return new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '';
}

/**
 * Parses a JSON config post. WordPress replaces straight quotes with typographic ones,
 * so they are turned back into ASCII quotes before parsing.
 */
export function parseJsonPost<T = unknown>(html: string): T {
    const json = htmlToText(html)
        .replace(DOUBLE_QUOTES, '"')
        .replace(SINGLE_QUOTES, "'")
        .replace(NO_BREAK_SPACE, ' ');
    return JSON.parse(json) as T;
}

/** Only when WordPress itself is configured with https (local development may use http). */
const UPGRADE_OWN_LINKS = WORDPRESS_URL.startsWith('https:');

/** Rewrites http:// links to our own hosts to https://, so they aren't blocked as mixed content. */
export function upgradeToHttps(value: string): string;
export function upgradeToHttps(value: string | undefined): string | undefined;
export function upgradeToHttps(value: string | undefined): string | undefined {
    return UPGRADE_OWN_LINKS ? value?.replace(OWN_HTTP_URL, 'https://$1') : value;
}
